import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick", "src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "upload-loader" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 5,
  class: "is-file-check"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-file",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 6,
  class: "is-file-check",
  style: {"z-index":"3","color":"var(--danger)"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-exclamation-triangle",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx, _cache) {
  const _component_photo_consumer = _resolveComponent("photo-consumer")
  const _component_photo_provider = _resolveComponent("photo-provider")

  return (_openBlock(), _createBlock(_component_photo_provider, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgList, (src, index) => {
        return (_openBlock(), _createBlock(_component_photo_consumer, {
          intro: _ctx.getValue(src),
          key: index,
          src: _ctx.getValue(src)
        }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  class: "skeleton"
                }))
              : _createCommentVNode("", true),
            (_ctx.errorSrc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  ref_for: true,
                  ref: "image",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  onLoad: _cache[2] || (_cache[2] = (...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args))),
                  onError: _cache[3] || (_cache[3] = (...args) => (_ctx.onImageError && _ctx.onImageError(...args))),
                  src: _ctx.errorSrc || _ctx.getValue(src),
                  class: _normalizeClass(["view-box", _ctx.className, { 'error-loaded': _ctx.errorSrc }]),
                  style: _normalizeStyle(_ctx.styleName)
                }, null, 46, _hoisted_1))
              : (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  ref_for: true,
                  ref: "image",
                  onLoad: _cache[4] || (_cache[4] = (...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args))),
                  onError: _cache[5] || (_cache[5] = (...args) => (_ctx.onImageError && _ctx.onImageError(...args))),
                  src: _ctx.errorSrc || _ctx.getValue(src),
                  class: _normalizeClass(["view-box", _ctx.className, { 'error-loaded': _ctx.errorSrc }]),
                  style: _normalizeStyle(_ctx.styleName)
                }, null, 46, _hoisted_2)),
            (_ctx.isDelete && !_ctx.readonly && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  class: "c-image-is-delete"
                }, [
                  _createElementVNode("img", {
                    onClick: $event => (_ctx.onDeleteImage(index)),
                    src: require('@/assets/icons/sidebars/delete.svg'),
                    alt: ""
                  }, null, 8, _hoisted_3)
                ]))
              : _createCommentVNode("", true),
            (_ctx.uploaded >= 1 && index === _ctx.uploadedIndex && _ctx.isFile(src))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                  class: "is-file-uploading"
                }, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.file && _ctx.isFile(src) && !_ctx.isError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.isError === src?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
              class: "img-action"
            }, [
              _renderSlot(_ctx.$slots, "img-action", { row: src })
            ], 512), [
              [_vShow, _ctx.isThumbnail && !_ctx.readonly && !_ctx.isLoading]
            ]),
            _withDirectives(_createElementVNode("div", {
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
              class: "img-action-2"
            }, [
              _renderSlot(_ctx.$slots, "img-action", { row: src })
            ], 512), [
              [_vShow, _ctx.isThumbnail && _ctx.thumbnail && _ctx.thumbnail === src && !_ctx.isLoading]
            ])
          ]),
          _: 2
        }, 1032, ["intro", "src"]))
      }), 128))
    ]),
    _: 3
  }))
}